export const breakpoints = {
  SMALL_PHONE: "320px",
  PHONE: "600px",
  LARGE_PHONE: "720px",
  TABLET: "1000px",
}
